import { Companion_instance1k9k9e3ajjzyi as Companion_instance } from './ActionPipe.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DispatcherPipeCannonClass;
function DispatcherPipeCannon() {
  if (DispatcherPipeCannonClass === VOID) {
    class $ {
      constructor(dispatcher, pipe) {
        pipe = pipe === VOID ? Companion_instance : pipe;
        this.x2g_1 = dispatcher;
        this.y2g_1 = pipe;
      }
      *z2g(action, $completion) {
        return yield* this.y2g_1.a2h(this.x2g_1, action, $completion);
      }
      toString() {
        return 'DispatcherPipeCannon(dispatcher=' + toString(this.x2g_1) + ', pipe=' + toString_0(this.y2g_1) + ')';
      }
      hashCode() {
        var result = this.x2g_1 == null ? 0 : hashCode(this.x2g_1);
        result = imul(result, 31) + hashCode(this.y2g_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DispatcherPipeCannon()))
          return false;
        if (!equals(this.x2g_1, other.x2g_1))
          return false;
        if (!equals(this.y2g_1, other.y2g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DispatcherPipeCannon', VOID, VOID, VOID, [1]);
    DispatcherPipeCannonClass = $;
  }
  return DispatcherPipeCannonClass;
}
//region block: exports
export {
  DispatcherPipeCannon as DispatcherPipeCannon3aitdk4bdtfxf,
};
//endregion

//# sourceMappingURL=ActionCannon.mjs.map
